<template><TableInvStock /></template>
<script>
import TableInvStock from '../inventory/TableInvStock.vue'
export default { name: 'ReportStock', components: { TableInvStock } }
</script>
